import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-guide-tooltip',
  templateUrl: './guide-tooltip.component.html',
  styleUrls: ['./guide-tooltip.component.scss']
})
export class GuideTooltipComponent {
  @Input() tooltipText: string = 'See the guide for more details';
  @Input() docSection: string = '';

  readonly baseUrl = 'https://help.conversell.ai/docs/other-builder/';

  openGuide() {
    const url = this.docSection
      ? `${this.baseUrl}#${this.docSection}`
      : this.baseUrl;
    window.open(url, '_blank');
  }
}